import { FlexBox, useToasts } from "@brg/ui";
import { FC, useMemo } from "react";
import styled from "styled-components";
import { DefaultButton } from "../styles";
import { useParams } from "react-router-dom";
import { API, Endpoints } from "@brg/api";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";

export enum ENTITY_COURSES_TYPE {
    course = 'course',
    group = 'group'
}

const SAME_NAME_STATUS = 409

export const Wrapper = styled(FlexBox)`
    height: 48px;
    margin-top: 0px;
    ${DefaultButton} {
        &:focus {
            outline: none !important;
        }
    }

    * {
        height: 48px;
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 40px;

        * {
            height: 40px;
            font-size: 13px;
            line-height: 16px;
        }

    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        height: 16px;
    }
`;

export const AutoChannelButton: FC<{ 
    type: ENTITY_COURSES_TYPE,
    entityId:string, 
    channelId: string,
    status?: string,
    onUpdate?: (value: any) => void
    onSetChannelId?: (id: string, groupId: string) => void
}> = ({ 
    type,
    entityId, 
    channelId,
    status,
    onUpdate,
    onSetChannelId 
}) => {
    const { t } = useTranslation();
    const { error } = useToasts();
    
    const onCreateChannel = async() => {
        if (!entityId) return;

        if (!!channelId?.length) {
            window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/team-edit/' + channelId, '_BLANK');
            return;
        }

        // const method = type === ENTITY_COURSES_TYPE.course ? 
        //     'GetDefaultCourseChannel' : 'GetDefaultCourseGroupChannel'
        const method = 'GetDefaultCourseGroupChannel'
        // const query = type === ENTITY_COURSES_TYPE.course ? 
        //     'teamId' : 'groupId';
        const query = 'groupId'

        await API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Lms/${method}`)
        .addQuery(query, entityId)
        .get()
        .send()
        .then((response) => {
            if (response.status === SAME_NAME_STATUS) {
                error('Такое название уже существует.')
            }
            if (response.status === 404) {
                error('Что-то пошло не так')
            }
            return response.json()
        })
        .then((r) => {
            onUpdate?.(Date.now())
            onSetChannelId?.(r as string, entityId)
        })
    }

    const title = useMemo(() => {
        if (!!channelId?.length) {
            return t('teams.adminPage.additionalFields.auto_channel_go')
        }

        return t('teams.adminPage.additionalFields.auto_channel_add')
    } , [channelId])

    return (
        <Wrapper>
            <DefaultButton
                wh={157}
                whMob={157} 
                onClick={onCreateChannel}
            >
                {title}
            </DefaultButton>
        </Wrapper>
    )
}import { FlexBox, useToasts } from "@brg/ui";
import { FC, useMemo } from "react";
import styled from "styled-components";
import { DefaultButton } from "../styles";
import { useParams } from "react-router-dom";
import { API, Endpoints } from "@brg/api";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";

export enum ENTITY_COURSES_TYPE {
    course = 'course',
    group = 'group'
}

const SAME_NAME_STATUS = 409

export const Wrapper = styled(FlexBox)`
    height: 48px;
    margin-top: 0px;
    ${DefaultButton} {
        &:focus {
            outline: none !important;
        }
    }

    * {
        height: 48px;
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 40px;

        * {
            height: 40px;
            font-size: 13px;
            line-height: 16px;
        }

    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        height: 16px;
    }
`;

export const AutoChannelButton: FC<{ 
    type: ENTITY_COURSES_TYPE,
    entityId:string, 
    channelId: string,
    status?: string,
    onUpdate?: (value: any) => void
    onSetChannelId?: (id: string, groupId: string) => void
}> = ({ 
    type,
    entityId, 
    channelId,
    status,
    onUpdate,
    onSetChannelId 
}) => {
    const { t } = useTranslation();
    const { error } = useToasts();
    
    const onCreateChannel = async() => {
        if (!entityId) return;

        if (!!channelId?.length) {
            window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/team-edit/' + channelId, '_BLANK');
            return;
        }

        // const method = type === ENTITY_COURSES_TYPE.course ? 
        //     'GetDefaultCourseChannel' : 'GetDefaultCourseGroupChannel'
        const method = 'GetDefaultCourseGroupChannel'
        // const query = type === ENTITY_COURSES_TYPE.course ? 
        //     'teamId' : 'groupId';
        const query = 'groupId'

        await API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Lms/${method}`)
        .addQuery(query, entityId)
        .get()
        .send()
        .then((response) => {
            if (response.status === SAME_NAME_STATUS) {
                error('Такое название уже существует.')
            }
            if (response.status === 404) {
                error('Что-то пошло не так')
            }
            return response.json()
        })
        .then((r) => {
            onUpdate?.(Date.now())
            onSetChannelId?.(r as string, entityId)
        })
    }

    const title = useMemo(() => {
        if (!!channelId?.length) {
            return t('teams.adminPage.additionalFields.auto_channel_go')
        }

        return t('teams.adminPage.additionalFields.auto_channel_add')
    } , [channelId])

    return (
        <Wrapper>
            <DefaultButton
                wh={157}
                whMob={157} 
                onClick={onCreateChannel}
            >
                {title}
            </DefaultButton>
        </Wrapper>
    )
}